export default "__VITE_ASSET__kVimO515__"